import { render, staticRenderFns } from "./SmartReviews.vue?vue&type=template&id=6ad1842f"
import script from "./SmartReviews.vue?vue&type=script&lang=js"
export * from "./SmartReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports